import React, { Fragment } from 'react'
import styled from 'styled-components'
import { Carousel } from '@merchantlabs/react-carousel'

import Image from './image'

export default ({ heading, images }) => (
  <Fragment>
    <ImageText>{heading}</ImageText>
    {console.log(images)}
    <Carousel buttonComponent={ArrowButton} dotComponent={Carousel.Dot}>
      {images.map((image, i) => (
        <Image key={i} sizes={image.image.childImageSharp.fluid} />
      ))}
    </Carousel>
  </Fragment>
)

const ImageText = styled.div`
  font-size: 30px;
  color: ${props => props.theme.fontColor};
  font-family: ${props => props.theme.secondaryFont};
  font-weight: ${props => props.theme.bold};
  width: 90%;
  text-align: center;
  margin: 30px;
`
const ArrowButton = Carousel.Button.extend`
  background: rgba(0, 0, 0, .4);

  &:hover {
    background: rgba(0, 0, 0, .6);
  }

  @media (max-width: ${props => props.theme.tablet}px) {
    display: none;
  }
`
